import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;
const cookieDomain = import.meta.env.VITE_COOKIE_DOMAIN as string | undefined;

const domainAttr = cookieDomain ? `; domain=${cookieDomain}` : "";

const cookieStorage = {
  getItem(key: string): string | null {
    const match = document.cookie.split("; ").find((c) => c.startsWith(`${key}=`));
    return match ? decodeURIComponent(match.slice(key.length + 1)) : null;
  },
  setItem(key: string, value: string): void {
    document.cookie = `${key}=${encodeURIComponent(value)}; path=/${domainAttr}; max-age=2592000; SameSite=Lax`;
  },
  removeItem(key: string): void {
    document.cookie = `${key}=; path=/${domainAttr}; max-age=0`;
  },
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: { storage: cookieStorage, persistSession: true },
});
